<span class="text-gray-darker">{{ settings.getAppSetting('name') }} &copy; {{settings.getAppSetting('year')}} version {{ ceqVersion }}</span>
